import React from "react";

const NonSelectableRadio = ({ checked, size = "md",color }) => {
  return (
    <div
      className={`selectable-radio ${size} ${checked ? "checked" : ""}`}
      role="radio"
      style={{borderColor:!checked && "#FFA500"}}
      aria-checked={checked}
    >
{checked?
      <svg className={size} viewBox="0 0 24 24" fill="none">
        <line
          x1="5"
          y1="12"
          x2="19"
          y2="12"
          stroke="#ffffff"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      :
      <svg className={size} viewBox="0 0 24 24" fill="none">
  <circle
    cx="12"
    cy="12"
    r="9"
    fill={"#FFA500"}
    strokeWidth="3"
    // opacity="0.2"
  />
  <path
    d="M21 12a9 9 0 0 1-9 9"
    fill={"#FFA500"}
    strokeWidth="3"
    strokeLinecap="round"
  />

</svg>}
    </div>
  );
};

export default NonSelectableRadio;
